import { FC } from 'react'
import { IUserBase } from '@/types'
import { getUserAvatar } from '@/utils'
import { AvatarContentFullCard } from '@components-v2/molecules/AvatarContentFullCard'
import { AngelCardContent } from '@components-v2/molecules/AngelCardContent'

type Props = {
  item: IUserBase
}
export const AngelCard: FC<Props> = ({ item }) => {
  return (
    <AvatarContentFullCard
      src={getUserAvatar(item)}
      href={`/users/${item.username}`}
      withVerifiedTick={item.profile.isVerifiedAccount}
    >
      <AngelCardContent user={item} />
    </AvatarContentFullCard>
  )
}
